import { select } from "d3-selection";

export default selector => {
  let data = [];

  const $ = () => {
    const selection = select(selector);

    const steps = selection.selectAll(".homePage").data(data, function(d) {
      return d.step;
    });

    const container = steps
      .enter()
      .append("div")
      .attr("class", function(d) {
        return `step vh-100 w-100 homePage`;
      })
      .style("background-image", function(d) {
        return `url(${d.img_url})`;
      })
      .append("div")
      .attr("class", "container h-100 d-flex flex-column");

    container
      .append("div")
      .attr(
        "class",
        "row align-items-center justify-content-center flex-grow-0 flex-shrink-0"
      )
      .append("div")
      .attr("class", "col-12 text-center")
      .append("img")
      .attr("class", "home-logo")
      .attr("src", "logo.svg");

    const col = container
      .append("div")
      .attr(
        "class",
        "row align-items-center justify-content-center flex-grow-1 flex-shrink-1"
      )
      .append("div")
      .attr("class", "col-12");

    col
      .append("h6")
      .attr("class", "text-center text-uppercase")
      .text("interactive report");

    col
      .append("h1")
      .attr("class", "text-center home-text")
      .text(function(d) {
        return d.text;
      });

    col
      .append("p")
      .attr("class", "text-center home-desc")
      .text(function(d) {
        return d.desc;
      });

    const foot = container
      .append("div")
      .attr(
        "class",
        "row align-items-center justify-content-center flex-grow-0 flex-shrink-0"
      )
      .append("div")
      .attr("class", "col-12 text-center");

    foot
      .append("img")
      .attr("class", "home-logo-eu")
      .attr("src", "eu.png");

    foot
      .append("p")
      .attr("class", "text-black-50")
      .text("© Copyright 2017-2021 OPTICS2 Project. All rights reserved.");
  };

  $.data = _ => {
    data = _;
    return $;
  };

  return $;
};
